import { useCallback } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Autocomplete } from '@material-ui/lab'

import { useAwesomeBarContext } from '../AwesomeBarContext'
import { IOption } from '../types'
import Input from './Input'
import Results from './Results'

const useStyles = makeStyles((theme) => ({
  autocomplete: {
    width: '100%',
  },
  dropdown: {
    position: 'absolute',
    maxWidth: '640px',
    minWidth: '280px',
    width: 'calc(100vw - 175px)',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      position: 'absolute',
    },
  },
  endAdornment: {
    marginRight: '0',
    marginLeft: '4px',
    position: 'relative',
  },
  clearIndicator: {
    visibility: 'visible',
  },
}))

export const getOptionLabel = (option: IOption) => option.label

const Typeahead = () => {
  const { configsByLabel, inputRef, loading, onChange, onFocus, onInputChange, results, showResults, searchTerm } =
    useAwesomeBarContext()

  const classes = useStyles()

  const renderOption = useCallback(
    (result) => {
      const { searchTypeLabel } = result
      const config = configsByLabel[searchTypeLabel]
      const ResultComponent = config.ResultComponent
      return <ResultComponent {...result} />
    },
    [configsByLabel],
  )

  const hasSearchTerm = searchTerm.length > 0

  return (
    <Autocomplete
      id="main-nav-search-bar"
      autoComplete={false}
      autoHighlight={true}
      classes={{
        popper: classes.dropdown,
        paper: classes.dropdown,
        endAdornment: classes.endAdornment,
        clearIndicator: hasSearchTerm ? classes.clearIndicator : undefined,
      }}
      clearOnEscape
      disablePortal
      filterOptions={(i) => i}
      freeSolo
      getOptionLabel={getOptionLabel}
      inputValue={searchTerm}
      loading={loading}
      options={results || []}
      renderOption={renderOption}
      renderInput={(params) => (
        <Input
          {...params}
          loading={loading}
          inputRef={inputRef}
        />
      )}
      size="small"
      open={showResults}
      onChange={onChange}
      onFocus={onFocus}
      onInputChange={(_e, term, reason) => {
        if (reason === 'reset') {
          return
        }
        onInputChange(term)
      }}
      PaperComponent={Results}
    />
  )
}

export default Typeahead
